import { Columns2 } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ButtonEditorRenderer } from "./editor";
import { ButtonEmailRenderer } from "./email";
import type { RowBlock, RowBlockProps, RowLayout } from "./types";
import { ButtonEmailPanelRenderer } from "./email-panel";
import RowWeb from "./web";
import { RowWebEditor } from "./web-editor";
import {
  Layout3333Preview,
  Layout444Preview,
  Layout48Preview,
  Layout66Preview,
  Layout84Preview,
  LayoutPreviewProps,
} from "./layout-previews";
import { isBlockTranslated } from "../index";

export const RowLayoutPresets: Record<
  RowLayout,
  {
    id: RowLayout;
    name: string;
    Preview: React.ComponentType<LayoutPreviewProps>;
  }
> = {
  "6-6": {
    id: "6-6",
    name: "2 colonnes égales",
    Preview: Layout66Preview,
  },
  "4-4-4": {
    id: "4-4-4",
    name: "3 colonnes égales",
    Preview: Layout444Preview,
  },
  "3-3-3-3": {
    id: "3-3-3-3",
    name: "4 colonnes égales",
    Preview: Layout3333Preview,
  },
  "8-4": {
    id: "8-4",
    name: "2 colonnes (large/étroit)",
    Preview: Layout84Preview,
  },
  "4-8": {
    id: "4-8",
    name: "2 colonnes (étroit/large)",
    Preview: Layout48Preview,
  },
};

export default registerBlock<RowBlockProps>({
  type: "row",
  name: "editorBlocksLibrary.blocks.row.title",
  description: "editorBlocksLibrary.blocks.row.description",
  Icon: Columns2,
  category: BlockCategory.LAYOUT,
  isTranslated: (locale, block) => {
    const children = (block as RowBlock).content?.children;

    if (!children?.length) {
      return true;
    }
    return children.every((child) => isBlockTranslated(locale, child!));
  },
  components: {
    email: {
      component: ButtonEmailRenderer,
      editor: {
        component: ButtonEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ButtonEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
    web: {
      component: RowWeb,
      editor: {
        component: RowWebEditor,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ButtonEmailPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});
